import { Loadable } from '@gdp/react-app/lib/helpers/loadable';

export const LoadableDriverSalaryRoutes = Loadable(
  './DriverSalaryRoutes',
  () => import(/* webpackChunkName: "DriverSalary" */ './DriverSalaryRoutes'),
  () => [(require as any).resolveWeak('./DriverSalaryRoutes')]
);
